<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="isVisibleBrand"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #company_id>
        <a-select
          v-decorator="[
            'company_id',
            { rules: [{ required: true, message: '请选择合作企业' }] },
          ]"
          placeholder="请选择合作企业"
        >
          <a-select-option
            v-for="item in companyData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.companyInfo.qichacha_name }}
          </a-select-option>
        </a-select>
      </template>
      <template #name>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入赠品名称',
                },
              ],
            },
          ]"
          placeholder="请输入赠品名称"
        />
      </template>
      <template #link_products>
        <a-select
          v-decorator="[
            'link_products',
            { rules: [{ required: true, message: '请选择产品' }] },
          ]"
          mode="multiple"
          placeholder="请选择产品"
        >
          <a-select-option
            v-for="item in link_products"
            :key="item.id"
            :value="item.id"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </template>
      <template #upload>
        <a-upload
          v-decorator="[
            'attach_doc_ids',
            { rules: [{ required: true, message: '请选择附件' }],
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          :with-credentials="false"
          :data="{fileType:'file',}"
          :action="`${uploadUrl}system/upload`"
          @change="handleChangeUpload"
        >
          <a-button> <a-icon type="upload" /> 点击上传 </a-button>
        </a-upload>
      </template>
      <template #summary>
        <a-textarea
          v-decorator="[
            'summary',
            { rules: [{ required: true, message: '请输入说明' }] },
          ]"
          rows="6"
          placeholder="请输入说明"
          maxlength="150"
        />
      </template>
    </basic-form>
    <slot />
  </a-modal>
</template>
<script>
import { companyFormData } from '../data/index';
export default {
  props: ['isVisibleBrand', 'title'],
  data() {
    return {
      formData: companyFormData,
      link_products: [],
    };
  },
  mounted() {
    // 获取产品
    this.getProductList();
    // 获取企业
    this.getCompanyList();
  },
  methods: {
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post('/Company/getCooperationCompanyList');
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
      }
    },
    // 获取产品
    async getProductList() {
      let result = await this.$http.post('/product/getList');
      if (result.data.status === 1) {
        this.link_products = result.data.data.data_list.filter((item)=>item.status===1);;
      }
    },
    // 上传
    handleChangeUpload(event){
      if(event.file.response&&event.file.response.status===0){
        this.$message.warning(event.file.response.msg);
      }
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      let data=[];
      e.fileList.forEach((item)=>{
        if(item.response&&item.response.status===0){
          return ;
        }else{
          data.push(item);
        }
      });
      e.fileList=data;
      return e && e.fileList;
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
